module.exports = __webpack_public_path__ + "img/accarr.e0f3feaa.svg";